import React from 'react';

const BorderTd = ({ children, colSpan = 1, rowSpan = 1, className = "", mergeTable = false, bold = false }) => {
    return (
        <td className={[`border border-[#f6f6f6] px-2 py-2`, mergeTable ? "border-t-0!" : "",  bold ? "text-zinc-500!" : "font-normal!", className].join(" ")}
            colSpan={colSpan} rowSpan={rowSpan}>
            {children}
        </td>
    );
};

export default BorderTd;